import { createContext, useContext } from 'react'

export const DrawerContext = createContext({ openDrawer: () => {} })

export function useDrawer() {
  return useContext(DrawerContext)
}
